"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseSchema_1 = require("../baseSchema");
const baseViewSchema_1 = require("../baseSchema/baseViewSchema");
class ViewMembershipMediaUploadSchema extends baseViewSchema_1.BaseViewSchema {
    constructor() {
        super(...arguments);
        this.action = baseSchema_1.ActionsName.VIEW_MEMBERSHIP_MEDIA_UPLOAD;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            action: this.action
        };
    }
}
exports.default = ViewMembershipMediaUploadSchema;
